'use strict';

var TweenOne = require('./TweenOne');
TweenOne.TweenOneGroup = require('./TweenOneGroup');
TweenOne.easing = require('./easing');
TweenOne.plugins = require('./plugins');
TweenOne.ticker = require('./ticker');
TweenOne.isTweenOne = true;
module.exports = TweenOne;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tween-one/lib/index.js
// module id = 361
// module chunks = 1